import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const purchases = [{
  name: 'Matías A.',
  city: 'Posadas',
  country: 'Misiones, Argentina'
}, {
  name: 'Valeria G.',
  city: 'Corrientes',
  country: 'Argentina'
}, {
  name: 'Ricardo S.',
  city: 'Formosa',
  country: 'Argentina'
}, {
  name: 'Roberto M.',
  city: 'Paraná',
  country: 'Entre Ríos, Argentina'
}, {
  name: 'Lucía E.',
  city: 'Resistencia',
  country: 'Chaco, Argentina'
}, {
  name: 'Marcos T.',
  city: 'Salta',
  country: 'Argentina'
}, {
  name: 'Sandra P.',
  city: 'Oberá',
  country: 'Misiones, Argentina'
}, {
  name: 'Diego H.',
  city: 'Goya',
  country: 'Corrientes, Argentina'
}, {
  name: 'Carolina V.',
  city: 'Mar del Plata',
  country: 'Argentina'
}, {
  name: 'Andrés R.',
  city: 'Bariloche',
  country: 'Río Negro, Argentina'
}, {
  name: 'Javier P.',
  city: 'Mendoza',
  country: 'Argentina'
}, {
  name: 'Sofía M.',
  city: 'Tucumán',
  country: 'Argentina'
}, {
  name: 'Carlos M.',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Ana Lucía T.',
  city: 'Guayaquil',
  country: 'Ecuador'
}, {
  name: 'Fernando L.',
  city: 'Lima',
  country: 'Perú'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const initial = setTimeout(showNext, 5000);
    return () => clearTimeout(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showNext = () => {
    const random = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrent(random);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNext, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed top-4 right-4 z-50 max-w-[260px] md:max-w-[280px] animate-[slideInRight_0.5s_ease-out]" data-id="element-213">
      <div className="bg-white rounded-xl border-[3px] border-brand-orange p-2.5 shadow-[0_5px_0_#1A365D,0_10px_24px_rgba(26,54,93,0.3)] flex items-start gap-2 relative" data-id="element-214">
        <button onClick={() => setIsVisible(false)} className="absolute -top-2 -right-2 bg-brand-navy text-white rounded-full w-5 h-5 flex items-center justify-center border-2 border-white" aria-label="Cerrar" data-id="element-215">
          <X className="w-2.5 h-2.5" strokeWidth={3} data-id="element-216" />
        </button>
        <div className="bg-brand-green rounded-full p-1 shrink-0 border-2 border-white" data-id="element-217">
          <CheckCircle className="w-3.5 h-3.5 text-white" strokeWidth={3} data-id="element-218" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-219">
          <p className="text-[11px] text-brand-navy font-bold leading-tight" data-id="element-220">
            <span className="font-display font-bold uppercase" data-id="element-221">
              {current.name}
            </span>{' '}
            de{' '}
            <span className="font-bold" data-id="element-222">
              {current.city}, {current.country}
            </span>
          </p>
          <p className="text-[11px] text-brand-ink font-medium leading-tight mt-0.5" data-id="element-223">
            acaba de comprar el{' '}
            <span className="font-bold text-brand-orange" data-id="element-224">
              Sistema Acuicultura Pro™
            </span>{' '}
            🐟
          </p>
          <p className="text-[9px] text-brand-mute font-bold uppercase tracking-widest mt-0.5" data-id="element-225">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-226">{`
        @keyframes slideInRight {
          from { transform: translateX(120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}